export enum CartAnalyticsEnum {
  OPEN_CART = '[PAC WEB] Carrinho - Abriu carrinho',
  ADD_MORE_PROCEDURES = '[PAC WEB] Carrinho - Adicionou mais consultas ou exames',
  ADD_ITEM = '[PAC WEB] Carrinho - Adicionou item',
  REMOVE_ITEMS = '[PAC WEB] Carrinho - Removeu item',
  CONFIRM_PHONE = '[PAC WEB] Carrinho - Confirmou telefone',
  UPDATE_PHONE = '[PAC WEB] Carrinho - Atualizou telefone',

  APPLY_COUPON = '[PAC WEB] Carrinho - Aplicou cupom',
  REMOVE_COUPON = '[PAC WEB] Carrinho - Removeu cupom',
  COUPON_ERROR = '[PAC WEB] Carrinho - Erro ao aplicar cupom',

  OPEN_CHANGE_PATIENT = '[PAC WEB] Carrinho - Abriu troca de paciente',
  CHANGE_PATIENT = '[PAC WEB] Carrinho - Alterou paciente',

  OPEN_CHANGE_SCHEDULE = '[PAC WEB] Carrinho - Abriu troca de horário',
  CHANGE_SCHEDULE = '[PAC WEB] Carrinho - Alterou horário',

  VIEW_CART_CLEAR_CONFIRMATION = '[PAC WEB] Carrinho - Exibiu confirmação de esvaziar carrinho',
  CONFIRM_CART_CLEAR = '[PAC WEB] Carrinho - Confirmou esvaziar carrinho',
  CANCEL_CART_CLEAR = '[PAC WEB] Carrinho - Manteve o carrinho',
}

export enum CartClearMotive {
  ADDING_STANDALONE = 'guia_avulsa_entrando',
  CART_HAS_STANDALONE = 'carrinho_com_guia_avulsa',
}

export enum CartRemovalScope {
  ITEM = 'item',
  GROUP = 'grupo',
  SLOT = 'horario',
}

export enum CartChangePatientScope {
  ITEM = 'item',
  GROUP = 'grupo',
}

export enum CartChangeScheduleScope {
  ITEM = 'item',
  GROUP = 'grupo',
}

export enum CartOrigin {
  SEARCH_RESULTS = 'resultado_busca',
  PROFILE = 'perfil',
  HOME = 'home',
  APPOINTMENTS = 'agendamentos',
  OTHER = 'outro',
}

export enum AddMoreProceduresDestination {
  CLOSED_MODAL = 'fechou_modal',
  SEARCH = 'busca',
}
